// tslint:disable:no-unsafe-any (autogenerated)
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { generic, GENERIC_STORE_ACTION, GENERIC_DISPATCHER_ACTION } from './generic-store-reducer';
import { IAppState } from '../../services/app-state';
import { TAppAction } from '../../services/app-action';
import { SagaIterator } from '../../services/app-saga';

export type TReducer<T extends {}, A extends TAppAction> = (state: T, action: A) => T;

// tslint:disable-next-line:interface-over-type-literal (autogenerated)
export type TReducers = { [reducerId: string]: TReducer<{}, TAppAction> };

const sagaMiddleware = createSagaMiddleware();

const actionSanitizer = (action: TAppAction): { type: string } => {
    if (action.type === GENERIC_STORE_ACTION) {
        return { type: GENERIC_STORE_ACTION + action.storeId };
    }
    if (action.type === GENERIC_DISPATCHER_ACTION) {
        return { type: GENERIC_DISPATCHER_ACTION + action.eventName };
    }
    return action;
};

const stateSanitizer = (state: IAppState): IAppState => state;

const predicate = (state: IAppState, action: TAppAction): boolean =>
    action.type !== GENERIC_DISPATCHER_ACTION ||
    (action.eventName.indexOf('setPlayer') < 0 && action.eventName.indexOf('LegacyStore') < 0);

const DEV_TOOL_ENHANCERS = '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__';
const composeEnhancers =
    typeof window !== 'undefined' && window[DEV_TOOL_ENHANCERS]
        ? window[DEV_TOOL_ENHANCERS]({
              maxAge: 500,
              actionSanitizer,
              stateSanitizer,
              predicate
          })
        : compose;

const connectedReducers = { generic: generic as TReducer<{}, TAppAction> };

const store = createStore<IAppState, TAppAction, {}, {}>(
    combineReducers<IAppState, TAppAction>(connectedReducers),
    composeEnhancers(applyMiddleware(sagaMiddleware))
);

/*
 Dynamically add new reducer to store.
 It should be called from  modules/module_name.ts files only
 */

export function connectReducers(reducers: TReducers): void {
    for (const name of Object.keys(reducers)) {
        if (connectedReducers[name]) {
            throw new Error(`Module ${name} already connected.`);
        }

        connectedReducers[name] = reducers[name];
    }
    // tslint:disable-next-line:no-inferred-empty-object-type (autogenerated)
    const nextReducer = combineReducers(connectedReducers);
    store.replaceReducer(nextReducer);
}

export type TSaga = (getState?: () => IAppState) => SagaIterator;

/**
 * Dynamically register and run new saga
 * It should be called from  modules/module_name.ts files only
 * For more information about sagas please check
 * https://github.com/redux-saga/redux-saga
 * @param saga - saga to run
 **/
export function runSaga(saga: TSaga): void {
    sagaMiddleware.run(saga);
}

/*
 Don't use store directly. Use exported
 functions from containers/application-view-model.ts.
 Motivation is protect store from rewriting and reduce
 number of imports.
 */
export const dispatch: (action: TAppAction) => void = store.dispatch;

export const getState = store.getState;

export const subscribe: (listener: () => void) => () => void = store.subscribe;

// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
